// ============================================================
// PinMark - "pinned 6, the sheet gives 5": one hand-set value, and the
// button that lets it go.
// ============================================================
import type { Pin } from '../../engine/roster/pins';
import { plain as shown } from '../../engine/roster/sheetChanges';
import styles from './Sheet.module.css';

interface PinMarkProps {
  pin: Pin;
  disabled?: boolean;
  onReset: (pin: Pin) => void;
}

export default function PinMark({ pin, disabled, onReset }: PinMarkProps) {
  const name = pin.leaf ? `${pin.key}-${pin.leaf}` : pin.key;
  return (
    <button
      type="button"
      className={styles.pinMark}
      data-testid={`pin-${name}`}
      disabled={disabled}
      title={`Pinned by hand. The sheet gives ${shown(pin.sheetValue)}. Click to let the pin go.`}
      onClick={() => onReset(pin)}
    >
      <span className={styles.pinDot} aria-hidden="true" />
      {pin.label} pinned at {shown(pin.value)} (sheet {shown(pin.sheetValue)}) · reset
    </button>
  );
}
